<div class="ec-gse-data-container">
    <form [formGroup]="uploadDocForm" fxLayout="column" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutAlign="center center">
            <app-icon class="icon-xl txt-h-16-7" name="fal-file-excel"></app-icon>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" class="txt">
            {{'Excel upload provided by the GSE portal for the month of'|i18n}}
            &nbsp;<b>{{month|genericPipe}} {{year}}</b>:
        </div>
        <div class="mt-24" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div fxLayout="row" fxLayoutAlign="end"
                 fxFlex="30">{{ ('Upload file'|i18n) + ':*' }}
            </div>
            <div fxFlex="50" fxLayout="row"
                 fxLayoutAlign="start center" fxLayoutGap="20px">
                <input #fileSelect type="file" style="display: none"
                       [accept]="ACCEPTED_MIME_TYPES"
                       (change)="uploadDocument($event)">
                <button app-small-primary-button (click)="fileSelect.click()">
                    <app-icon [name]="currentDocument ? 'fal-sync' : 'fal-search'"></app-icon>
                    {{ (currentDocument ? 'Change file' : 'Upload file')|i18n }}
                </button>
                <div *ngIf="currentDocument">{{ currentDocument.filename }}</div>
                <div *ngIf="!currentDocument && uploadDocForm.controls.filename.dirty" app-error>
                    {{ 'No file uploaded'|i18n }}
                </div>
                <div *ngIf="!currentDocument && !uploadDocForm.controls.filename.dirty" class="txt-s-14-4">
                    {{ 'No document'|i18n }}
                </div>
            </div>
            <div fxFlex="20" fxLayoutAlign="start center">
                <div fxFlex="60" fxLayoutAlign="end center">
                    <button *ngIf="currentDocument" app-icon-button class="app-button-alert"
                            [title]="'Remove document'|i18n"
                            (click)="removeDocument()">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <div fxFlex="40"></div>
            </div>
        </div>
        <div class="mt-8" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div fxFlex="30">
            </div>
            <div fxFlex>
                <span class="txt-s-14-4">{{ '(Max {0} MB. Accepts only {1}.)'|i18n:MAX_FILE_MB:mimeTypesNames }}</span>
            </div>
            <div fxFlex="10"></div>
        </div>
    </form>
</div>
